module.exports = __webpack_public_path__ + "img/04-thumbnail.80c8ff5c.jpg";